import { useContext, useEffect, useCallback } from "react";
import RootContext from "../context/RootContext";
import { useLocation } from "react-router-dom";

const GoogleTranslate = () => {
  const { language, setIsTranslating } = useContext(RootContext);
   const location = useLocation();

  // 🔹 Google Translate API
  const translateText = async (text, target) => {
    try {
      const res = await fetch(
        `https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&tl=${target}&dt=t&q=${encodeURIComponent(
          text
        )}`
      );
      const data = await res.json();
      return data[0].map((t) => t[0]).join("");
    } catch (err) {
      console.error("Translate error:", err);
      return text; // fallback
    }
  };

  // 🔹 Collect all text nodes (memoized)
  const getAllTextNodes = useCallback((node) => {
    let textNodes = [];
    if (!node) return [];
    if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== "") {
      textNodes.push(node);
    } else if (
      node.nodeType === Node.ELEMENT_NODE &&
      !node.hasAttribute("data-no-translate")
    ) {
      node.childNodes.forEach((child) =>
        textNodes.push(...getAllTextNodes(child))
      );
    }
    return textNodes;
  }, []);

  // 🔹 Translate entire main content when language changes
  useEffect(() => {
    const translateContent = async () => {
      const main = document.getElementById("main-content");
      if (!main) return;

      const nodes = getAllTextNodes(main);
      if (nodes.length === 0) return;

      // Save original text (only once)
      nodes.forEach((n) => {
        if (!n.originalText) n.originalText = n.nodeValue;
      });

      // Restore English
      if (language === "en") {
        nodes.forEach((n) => (n.nodeValue = n.originalText));
        return;
      }

      // Start translating
      setIsTranslating(true);
      main.style.transition = "0.5s ease";

      // Combine all text nodes for batch translation
      const joinedText = nodes.map((n) => n.originalText).join("\n");
      const translatedAll = await translateText(joinedText, language);
      const translatedLines = translatedAll.split("\n");

      // Assign translated text line by line
      nodes.forEach((n, i) => {
        if (translatedLines[i]) n.nodeValue = translatedLines[i];
      });

      await new Promise((res) => setTimeout(res, 150));
      setIsTranslating(false);
    };

    translateContent();
}, [language, location.pathname, getAllTextNodes, setIsTranslating]); // 👈 location added here

  return null; // ✅ this is a background effect, no UI
};

export default GoogleTranslate;
